export default __webpack_public_path__ + "static/media/RESERVOIR-BENGALURU.bb59e181.jpg";